import ReactTooltip from "react-tooltip";
import Division from "../../../components/Division";
import Header from "../../../components/Header";
import Lateral from "../../../components/Lateral";
import { useEffect, useState } from "react";
import Title from "../../../components/Title";
import { FaArrowAltCircleLeft, FaCog } from "react-icons/fa";
import { Link, useHistory, useParams } from "react-router-dom"
import { handleInput, showMessageError } from "../../../classes/functions";
import api from "../../../config";
import { toast } from "react-toastify";

export default function CadURLs(){
    const [carrying, setCarrying] = useState(false);
    const { option, id } = useParams();
    const history = useHistory();
    const [view, setView] = useState(option === "v");
    const [inputsValues, setInputsValues] = useState({
        nome: "",
        ativo: null,
        host: "",
        path: "",
        funcoes: "",
        descricao: ""
    });

    function getURL(){
        api
        .get(`/api/parametrosUrl/${id}`)
        .then((response) => {
            setInputsValues((prevState) => ({...prevState, nome: response.data.nome, ativo: response.data.ativo, host: response.data.host, path: response.data.path, funcoes: response.data.funcoes, descricao: response.data.descricao}));
        })
        .catch((error) => {
            console.log(error);
        });
    }

    function cancel(){
        history.push("/urls");
    }

    function save(e){
        e.preventDefault();

        api
        [id ? "put" : "post"](`/api/parametrosUrl${id ? `/${id}` : "" }`, inputsValues)
        .then((response) => {
            console.log(response.data)
            toast.success("URL cadastrada com sucesso!");
            history.push("/urls");
        })
        .catch((error) => {
            console.log(error);
            showMessageError(error.response.data);
        });
    }

    function convertStringToBoolean(name, state, setState){
        const booleanInString = {
          "true": true,
          "false": false
        }

        setState((prevState) => ({...prevState, [name]: booleanInString[state]}));
    }

    useEffect(() => {
        if(id){
            getURL(); 
        }
    }, [id]);

    useEffect(() => {
        if(inputsValues.ativo){
            convertStringToBoolean("ativo", inputsValues.ativo, setInputsValues);
        }
    }, [inputsValues.ativo]);

    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />

            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner"/>
                </div>
            </div>}
            {!carrying && <div className="content">
                <Title name="Cadastro de URLs">
                    <Link to="/urls">
                        <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40}/>
                    </Link>
                </Title>   
                <div className="container">
                    <form className="form-profile customers">
                        <div className="containerGroupData">
                            <h2>Dados Cadastrais - {id}</h2>
                            <hr></hr>

                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Nome</label>&nbsp;<label className="required">*</label><br/>
                                    <input type="text" name="nome" placeholder="Nome" value={inputsValues.nome} onChange={(e) => handleInput(setInputsValues, e)} maxLength="150" disabled={view}/>
                                </div>
                                <div className="formDiv">
                                    <label>Status</label><br/>
                                    <select name="ativo" value={inputsValues.ativo} onChange={(e) => handleInput(setInputsValues, e)} disabled={view}>
                                        <option>Selecione</option>
                                        <option value={true}>Ativo</option>
                                        <option value={false}>Inativo</option>
                                    </select>
                                </div>
                                <div className="formDiv">
                                    <label>Host</label>&nbsp;<label className="required">*</label><br/>
                                    <input type="text" name="host" placeholder="Host" value={inputsValues.host} onChange={(e) => handleInput(setInputsValues, e)} maxLength="150" disabled={view}/>
                                </div>
                                <div className="formDiv">
                                    <label>Path</label>&nbsp;<label className="required">*</label><br/>
                                    <input type="text" name="path" placeholder="Path" value={inputsValues.path} onChange={(e) => handleInput(setInputsValues, e)} maxLength="150" disabled={view}/>
                                </div>
                                <div className="formDiv">
                                    <label>Funções</label>&nbsp;<label className="required">*</label><br/>
                                    <input type="text" name="funcoes" placeholder="Funções" value={inputsValues.funcoes} onChange={(e) => handleInput(setInputsValues, e)} maxLength="150" disabled={view}/>
                                </div>
                                <div className="formDiv">
                                    <label>Descrição</label>&nbsp;<label className="required">*</label><br/>
                                    <input type="text" name="descricao" placeholder="Descrição" value={inputsValues.descricao} onChange={(e) => handleInput(setInputsValues, e)} maxLength="150" disabled={view}/>
                                </div>
                            </div>
                        </div>
                        <br/>
                        {!view && <div className="formDiv">
                            <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>
                            <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
                        </div>}
                    </form>
                </div>
            </div>}
        </div>
    );
}